import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Candidate|History|Additional Agreements|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};
const columnHeadingDescriptionStart = 'Column heading for: ';

type LocNameStart = 'SPCandidateAdditionalAgreements';
export type SPCandidateAdditionalAgreementsLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelUpdated`
	| `${LocNameStart}LabelReviewStatus`
	| `${LocNameStart}LabelInvalid`
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelDocumentation`;

export const spCandidateAdditionalAgreementsLocs: LocDefs<SPCandidateAdditionalAgreementsLocNames> =
	{
		SPCandidateAdditionalAgreementsTitlePage: {
			defaultValue: 'Additional Agreements',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName:
				'OtherRequirement/Candidates.AdditionalAgreements.Title.AdditionalAgreements',
			...sharedProperties,
		},
		SPCandidateAdditionalAgreementsTitleTab: {
			defaultValue: 'Additional Agreements',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'OtherRequirement/Candidates.AdditionalAgreements.Title.Tab',
			...sharedProperties,
		},
		SPCandidateAdditionalAgreementsLabelName: {
			defaultValue: 'Name',
			description: `${columnHeadingDescriptionStart}Name.`,
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.AdditionalAgreements.ColumnHeading.Name',
			...sharedProperties,
		},
		SPCandidateAdditionalAgreementsLabelActiveDate: {
			defaultValue: 'Active Date',
			description: `${columnHeadingDescriptionStart}Active Date.`,
			displayPath: `${pathStart}Active Date`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.AdditionalAgreements.ColumnHeading.ActiveDate',
			...sharedProperties,
		},
		SPCandidateAdditionalAgreementsLabelExpireDate: {
			defaultValue: 'Expire Date',
			description: `${columnHeadingDescriptionStart}Expire Date.`,
			displayPath: `${pathStart}Expire Date`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.AdditionalAgreements.ColumnHeading.ExpireDate',
			...sharedProperties,
		},
		SPCandidateAdditionalAgreementsLabelUpdated: {
			defaultValue: 'Updated',
			description: `${columnHeadingDescriptionStart}Updated.`,
			displayPath: `${pathStart}Updated`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.AdditionalAgreements.ColumnHeading.Updated',
			...sharedProperties,
		},
		SPCandidateAdditionalAgreementsLabelReviewStatus: {
			defaultValue: 'Review Status',
			description: `${columnHeadingDescriptionStart}Review Status.`,
			displayPath: `${pathStart}Review Status`,
			displayType: 'Label',
			legacyName:
				'OtherRequirement/Candidates.AdditionalAgreements.ColumnHeading.ReviewStatus',
			...sharedProperties,
		},
		SPCandidateAdditionalAgreementsLabelInvalid: {
			defaultValue: 'Invalid',
			description: `${columnHeadingDescriptionStart}Invalid.`,
			displayPath: `${pathStart}Invalid`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.AdditionalAgreements.ColumnHeading.Invalid',
			...sharedProperties,
		},
		SPCandidateAdditionalAgreementsLabelDataProvider: {
			defaultValue: 'Data Provider',
			description: `${columnHeadingDescriptionStart}Data Provider.`,
			displayPath: `${pathStart}Data Provider`,
			displayType: 'Label',
			legacyName:
				'OtherRequirement/Candidates.AdditionalAgreements.ColumnHeading.DataProvider',
			...sharedProperties,
		},
		SPCandidateAdditionalAgreementsLabelDocumentation: {
			defaultValue: 'Documentation',
			description: `${columnHeadingDescriptionStart}Documentation.`,
			displayPath: `${pathStart}Documentation`,
			displayType: 'Label',
			legacyName:
				'OtherRequirement/Candidates.AdditionalAgreements.ColumnHeading.Documentation',
			...sharedProperties,
		},
	};

export type SPCandidateAdditionalAgreementsLocType =
	LocMap<SPCandidateAdditionalAgreementsLocNames>;
